import React, { useState, useContext } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { MyContext } from '../../Context/MyProvider';
const ImgPrev = ({ imgList, setImgPrev }) => {

    const { BaseUrl } = useContext(MyContext);

    const [currentIndex, setCurrentIndex] = useState(0);
    const [direction, setDirection] = useState(0);

    const variants = {
        enter: (direction) => ({
            x: direction > 0 ? 300 : -300,
            opacity: 0,
        }),
        center: {
            x: 0,
            opacity: 1,
        },
        exit: (direction) => ({
            x: direction > 0 ? -300 : 300,
            opacity: 0,
        }),
    };

    return (
        <div className="w-full h-full relative flex items-center justify-center">

            <button onClick={() => setImgPrev("")} className="absolute top-10 right-10">
                <svg width="28" height="28" className="text-gray-400 hover:text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="currentColor" />
                </svg>
            </button>

            {imgList.length > 1 && <button disabled={currentIndex == 0} onClick={() => {
                setDirection(-1);
                setCurrentIndex((prev) => prev - 1);
            }} className="absolute left-10 top-1/2 -translate-y-1/2 z-[222] max-_430_:top-[85%]">
                <svg width="24" height="24" className="text-gray-400 hover:text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 20C14.744 20 14.488 19.9021 14.293 19.7071L7.29301 12.7071C6.90201 12.3161 6.90201 11.684 7.29301 11.293L14.293 4.29301C14.684 3.90201 15.3161 3.90201 15.7071 4.29301C16.0981 4.68401 16.0981 5.31607 15.7071 5.70707L9.4141 12L15.7071 18.293C16.0981 18.684 16.0981 19.3161 15.7071 19.7071C15.5121 19.9021 15.256 20 15 20Z" fill="currentColor" />
                </svg>
            </button>}

            {imgList.length > 0 && (
                <div>
                    <div className="relative w-full h-full flex items-center justify-center">
                        <AnimatePresence custom={direction} initial={false} mode="wait">
                            <motion.img
                                key={currentIndex}
                                src={BaseUrl + imgList[currentIndex]}
                                custom={direction}
                                variants={variants}
                                initial="enter"
                                animate="center"
                                exit="exit"
                                transition={{ duration: 0.4, ease: "easeInOut" }}
                                className="max-w-full max-h-full"
                            />
                        </AnimatePresence>
                    </div>

                </div>
            )}

            {imgList.length == 0 && <img src={BaseUrl + imgList} alt="imgList" />}

            {imgList.length > 1 && <button disabled={currentIndex == imgList.length - 1} onClick={() => {
                setDirection(1);
                setCurrentIndex((prev) => prev + 1);
            }} className="absolute right-10 top-1/2 -translate-y-1/2 z-[222] max-_430_:top-[85%]">
                <svg width="24" height="24" className="text-gray-400 hover:text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.00004 20C8.74404 20 8.48801 19.9021 8.29301 19.7071C7.90201 19.3161 7.90201 18.684 8.29301 18.293L14.586 12L8.29301 5.70707C7.90201 5.31607 7.90201 4.68401 8.29301 4.29301C8.68401 3.90201 9.31607 3.90201 9.70707 4.29301L16.7071 11.293C17.0981 11.684 17.0981 12.3161 16.7071 12.7071L9.70707 19.7071C9.51207 19.9021 9.25604 20 9.00004 20Z" fill="currentColor" />
                </svg>
            </button>}

        </div>
    )
}

export default ImgPrev